<template>
  <div>
    <div class="terms">
      <div class="terms_title">{{ $t('bookOrder.termsTitle') }}</div>
      <div
        v-html="$store.state.baseConfig.baseConfigInfo.termsAndConditions"
        class="terms_main"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Terms',
  data() {
    return {};
  },

  methods: {},
};
</script>
<style scoped src="@/styles/super.css"></style>

<style lang="less" scoped>
// /deep/.terms_main p {
//   font-size: 20px;
//   font-weight: normal;
//   color: #020b3b;
//   line-height: 26px;
//   margin: 0;
// }
//
/deep/.terms_main {
  img {
    max-width: 815px;
    object-fit: cover;
  }
  video {
    max-width: 815px;
  }
  a {
    color: #020b3b;
    text-decoration: none;
  }
}
</style>
